export const getDatasetValueFromScript = (
  datasetKey: string,
  fallbackValue: string
) => {
  const domElScript = document.getElementById('aurr-js');

  return domElScript && domElScript.dataset[datasetKey]
    ? domElScript.dataset[datasetKey]
    : fallbackValue;
};
